import { resultImg, galleryUrl } from "@/lib/results-images";


const s1b = resultImg("slide-1-before");
const s1a = resultImg("slide-1-after");
const s2b = resultImg("slide-2-before");
const s2a = resultImg("slide-2-after");
const s3b = resultImg("slide-3-before");
const s3a = resultImg("slide-3-after");
const s4b = resultImg("slide-4-before");
const s4a = resultImg("slide-4-after");
const s5b = resultImg("slide-5-before");
const s5a = resultImg("slide-5-after");
const s6b = resultImg("slide-6-before");
const s6a = resultImg("slide-6-after");
const s7b = resultImg("slide-7-before");
const s7a = resultImg("slide-7-after");
const s8b = resultImg("slide-8-before");
const s8a = resultImg("slide-8-after");
const s9b = resultImg("slide-9-before");
const s9a = resultImg("slide-9-after");
const s10b = resultImg("slide-10-before");
const s10a = resultImg("slide-10-after");
const s11b = resultImg("slide-11-before");
const s11a = resultImg("slide-11-after");
const s12b = resultImg("slide-12-before");
const s12a = resultImg("slide-12-after");
const s13 = resultImg("slide-13");
const s14b = resultImg("slide-14-before");
const s14a = resultImg("slide-14-after");
const s15b = resultImg("slide-15-before");
const s15a = resultImg("slide-15-after");
const s16b = resultImg("slide-16-before");
const s16a = resultImg("slide-16-after");
const s17b = resultImg("slide-17-before");
const s17a = resultImg("slide-17-after");
const s18b = resultImg("slide-18-before");
const s18a = resultImg("slide-18-after");
const s19b = resultImg("slide-19-before");
const s19a = resultImg("slide-19-after");
const s20b = resultImg("slide-20-before");
const s20a = resultImg("slide-20-after");
const s21b = resultImg("slide-21-before");
const s21a = resultImg("slide-21-after");
const s22b = resultImg("slide-22-before");
const s22a = resultImg("slide-22-after");
const s23b = resultImg("slide-23-before");
const s23a = resultImg("slide-23-after");
const s24b = resultImg("slide-24-before");
const s24a = resultImg("slide-24-after");
const s25b = resultImg("slide-25-before");
const s25a = resultImg("slide-25-after");
const s26b = resultImg("slide-26-before");
const s26a = resultImg("slide-26-after");
const s27b = resultImg("slide-27-before");
const s27a = resultImg("slide-27-after");
const s28b = resultImg("slide-28-before");
const s28a = resultImg("slide-28-after");
// Rendered full-bleed inside the 33.408rem story column, not in a 2-up grid.
const s30 = resultImg("slide-30", "(min-width: 768px) 33rem, calc(100vw - 3rem)");
const s31 = resultImg("slide-31");
const s32 = resultImg("slide-32");
const s33b = resultImg("slide-33-before");
const s33a = resultImg("slide-33-after");


export type ImgRef = { url: string; srcSet?: string; sizes?: string; width?: number; height?: number };
export type Story = {
  name: string;
  quote?: string;
  before: ImgRef;
  after: ImgRef;
  beforePosition?: string;
  afterPosition?: string;
  aspectClass?: string;
  tagline?: string;
  single?: boolean;
  /** Unique, SEO-friendly label used for alt text, captions and structured data. */
  label: string;
  /** Short factual caption rendered under the photos and reused in ImageObject schema. */
  caption: string;
  /** Who took/owns the photo, when it differs from the practice default. */
  credit?: string;
  /** How the photo was obtained, when it differs from the practice default. */
  provenance?: string;
};

// Paula's photo is the LCP image on /results. The -v2 files are re-encoded
// (smaller) copies of the originals and are served, like every other gallery
// photo, from the immutable asset CDN.
const paulaImg: ImgRef = {
  url: galleryUrl("slide-29-660-v2.webp"),
  srcSet: `${galleryUrl("slide-29-480-v2.webp")} 480w, ${galleryUrl("slide-29-660-v2.webp")} 660w`,
  sizes: "(min-width: 768px) 33rem, calc(100vw - 3rem)",
  width: 900,
  height: 649,
};
const kcamposBeforeImg: ImgRef = {
  url: galleryUrl("kcampos-before-400.webp"),
  srcSet: `${galleryUrl("kcampos-before-400.webp")} 400w, ${galleryUrl("kcampos-before-800.webp")} 800w`,
  sizes: "(min-width: 768px) 16rem, 50vw",
};
const kcamposAfterImg: ImgRef = {
  url: galleryUrl("kcampos-after-400.webp"),
  srcSet: `${galleryUrl("kcampos-after-400.webp")} 400w, ${galleryUrl("kcampos-after-800.webp")} 800w`,
  sizes: "(min-width: 768px) 16rem, 50vw",
};
const newStoryBeforeImg: ImgRef = {
  url: galleryUrl("newstory-before-400.webp"),
  srcSet: `${galleryUrl("newstory-before-400.webp")} 400w, ${galleryUrl("newstory-before-800.webp")} 800w`,
  sizes: "(min-width: 768px) 16rem, 50vw",
};
const newStoryAfterImg: ImgRef = {
  url: galleryUrl("newstory-after-400.webp"),
  srcSet: `${galleryUrl("newstory-after-400.webp")} 400w, ${galleryUrl("newstory-after-800.webp")} 800w`,
  sizes: "(min-width: 768px) 16rem, 50vw",
};


export const stories: Story[] = [
  {
    name: "Paula C.",
    label: "Paula C.",
    caption: "Paula C.'s side-by-side weight-loss transformation after bariatric surgery with Dr. Matthew Fitzer in Northern Virginia.",
    before: paulaImg,
    after: paulaImg,
    single: true,
    aspectClass: "aspect-[4/3]",
  },



  {
    name: "Anonymous",
    label: "An anonymous Virginia Bariatric patient",
    caption: "An anonymous patient's before-and-after weight-loss result following bariatric surgery at Virginia Bariatric Surgery.",
    before: s30,
    after: s30,
    single: true,
  },
  {
    name: "Anonymous",
    label: "An anonymous patient who got her groove back",
    caption: "An anonymous patient back on the dance floor after weight-loss surgery with Dr. Matthew Fitzer.",
    before: s7b,
    after: s7a,
    aspectClass: "aspect-[15/16]",
    tagline: "Talk about getting your groove back!",
  },
  {
    name: "Anonymous",
    label: "An anonymous transformation",
    caption: "A before-and-after comparison of an anonymous Virginia Bariatric Surgery patient.",
    before: s21b,
    after: s21a,
    aspectClass: "aspect-[1/2]",
  },
  {
    name: "Anonymous",
    label: "Another amazing anonymous transformation",
    caption: "Another before-and-after comparison of an anonymous bariatric surgery patient in Northern Virginia.",
    before: s22b,
    after: s22a,
    aspectClass: "aspect-[1/2]",
  },
  {
    name: "Anonymous",
    label: "An anonymous patient’s one-year change",
    caption: "An anonymous patient's before-and-after change following weight-loss surgery at Virginia Bariatric Surgery.",
    before: s24b,
    after: s24a,
    aspectClass: "aspect-[1/1]",
  },
  {
    name: "M. M.",
    label: "M. M.",
    caption: "M. M. before and after weight-loss surgery with Dr. Matthew Fitzer at Virginia Bariatric Surgery.",
    before: s25b,
    after: s25a,
    aspectClass: "aspect-[3/4]",
    beforePosition: "center 20%",
    afterPosition: "45% center",
  },
  {
    name: "L. S.",
    label: "L. S.",
    caption: "L. S. photographed before and after bariatric surgery in Northern Virginia.",
    before: s26b,
    after: s26a,
    aspectClass: "aspect-[3/4]",
    beforePosition: "center 20%",
    afterPosition: "center 20%",
  },
  {
    name: "JDB",
    label: "JDB",
    caption: "JDB's before-and-after weight-loss result following surgery with Dr. Matthew Fitzer.",
    before: s27b,
    after: s27a,
    aspectClass: "aspect-[3/4]",
    beforePosition: "center 20%",
    afterPosition: "center 20%",
  },
  {
    name: "Jack A.",
    label: "Jack A.",
    caption: "Jack A. before and after his bariatric surgery journey at Virginia Bariatric Surgery.",
    before: s28b,
    after: s28a,
    aspectClass: "aspect-[3/4]",
  },
  {
    name: "Shelly T.",
    label: "Shelly T.",
    caption: "Shelly T.'s side-by-side weight-loss transformation after surgery with Dr. Matthew Fitzer.",
    before: s23b,
    after: s23a,
    aspectClass: "aspect-[4/5]",
    beforePosition: "center 30%",
    afterPosition: "center 20%",
  },
  {
    name: "Alfred and Patricia Crews",
    label: "Alfred and Patricia Crews",
    caption: "Alfred and Patricia Crews, a couple who had weight-loss surgery together at Virginia Bariatric Surgery.",
    before: s9b,
    after: s9a,
    aspectClass: "aspect-[4/5]",
    beforePosition: "center 20%",
    afterPosition: "center 15%",
  },
  {
    name: "Amanda G.",
    label: "Amanda G.",
    caption: "Amanda G. showing her weight-loss progress after bariatric surgery in Northern Virginia.",
    before: s13,
    after: s13,
    single: true,
  },
  {
    name: "Amanda G. (again)",
    label: "Amanda G., another view",
    caption: "Amanda G., another view of her weight-loss results with Dr. Matthew Fitzer.",
    before: s14b,
    after: s14a,
    aspectClass: "aspect-[5/6]",
  },
  {
    name: "Amanda R.",
    label: "Amanda R.",
    caption: "Amanda R. before and nearly two years after her gastric sleeve surgery with Dr. Matthew Fitzer.",
    quote:
      "Dr. Fitzer and his staff are FABULOUS! I had a bariatric sleeve done almost 2 years ago and I've never felt healthier. The support before and after surgery has been incredible.",
    before: s3b,
    after: s3a,
  },
  {
    name: "Ban H.",
    label: "Ban H.",
    caption: "Ban H.'s before-and-after weight-loss comparison following bariatric surgery in Northern Virginia.",
    before: s16b,
    after: s16a,
    aspectClass: "aspect-[7/8]",
  },
  {
    name: "Chad Beckhert",
    label: "Chad Beckhert",
    caption: "Chad Beckhert one year after his weight-loss surgery at Virginia Bariatric Surgery.",
    quote:
      "Good morning to the staff at Virginia Bariatrics — 1 year ago today you changed my life forever and for that I would like to thank the entire staff. From the first day I called to start my journey, your office has been hands down the best Dr. Office I've ever dealt with. I'm now in a much more enjoyable time in my life. I attached a couple before and after pictures for you to add to your board. Again I thank you for helping me through this process.",
    before: s8b,
    after: s8a,
    aspectClass: "aspect-[3/4]",
    beforePosition: "center 30%",
    afterPosition: "center 30%",
  },
  {
    name: "Cynthia Welgoss",
    label: "Cynthia Welgoss",
    caption: "Cynthia Welgoss, who began her surgical weight-loss journey with a BMI of 35, before and after.",
    quote:
      "With a BMI of 35, I was at the lower end of what many would say was heavy enough for surgery. Dr. Fitzer took my concerns seriously and helped me find a path that truly worked for me.",
    before: s5b,
    after: s5a,
  },
  {
    name: "E.M. and his mom",
    label: "E.M. and his mom",
    caption: "E.M. and his mother, both weight-loss surgery patients of Dr. Matthew Fitzer.",
    before: s11b,
    after: s11a,
    aspectClass: "aspect-[4/5]",
    beforePosition: "center 20%",
    afterPosition: "center 25%",
  },
  {
    name: "Happy Halloween!",
    label: "A Halloween-costume transformation",
    caption: "A Virginia Bariatric Surgery patient in Halloween costume before and after weight-loss surgery.",
    before: s15b,
    after: s15a,
    aspectClass: "aspect-[1/1]",
  },
  {
    name: "Jason Lamprey",
    label: "Jason Lamprey",
    caption: "Jason Lamprey before and after his bariatric surgery with Dr. Matthew Fitzer.",
    quote:
      "So thankful to have found Virginia Bariatric and Dr. Fitzer. My life has forever been changed. The whole team walked me through every step and celebrated every milestone with me.",
    before: s2b,
    after: s2a,
  },
  {
    name: "Kristina and Sean",
    label: "Kristina and Sean",
    caption: "Kristina and Sean, a couple who had weight-loss surgery together in Northern Virginia.",
    tagline: "Power couple!",
    before: s18b,
    after: s18a,
    aspectClass: "aspect-[3/4]",
    beforePosition: "center 60%",
    afterPosition: "center 60%",
  },
  {
    name: "Lori M.",
    label: "Lori M.",
    caption: "Lori M.'s before-and-after weight-loss result following surgery at Virginia Bariatric Surgery.",
    before: s17b,
    after: s17a,
    aspectClass: "aspect-[4/3]",
    afterPosition: "30% center",
  },
  {
    name: "Lorraine W.",
    label: "Lorraine W.",
    caption: "Lorraine W. photographed before and after her bariatric surgery with Dr. Matthew Fitzer.",
    before: s19b,
    after: s19a,
    aspectClass: "aspect-[4/5]",
    beforePosition: "center 3%",
    afterPosition: "center 3%",
  },
  {
    name: "Lucretia Dennington",
    label: "Lucretia Dennington",
    caption: "Lucretia Dennington's side-by-side weight-loss transformation in Northern Virginia.",
    before: s10b,
    after: s10a,
    aspectClass: "aspect-[4/5]",
    beforePosition: "center 30%",
    afterPosition: "center 25%",
  },
  {
    name: "Michael T.",
    label: "Michael T.",
    caption: "Michael T. before and after the surgery he says changed his life.",
    quote:
      "When my wife and I first met with Dr. Fitzer, he asked me what I would say if he told me he could change my life. Today I know exactly what to say — thank you.",
    before: s4b,
    after: s4a,
  },
  {
    name: "Mr. G",
    label: "Mr. G",
    caption: "Mr. G after his weight-loss surgery at Virginia Bariatric Surgery.",
    before: s12b,
    after: s12a,
    tagline: "Forgot his before. Se la vie...",
  },
  {
    name: "Shona Gardner",
    label: "Shona Gardner",
    caption: "Shona Gardner three years after her weight-loss surgery with Dr. Matthew Fitzer.",
    quote:
      "3 years ago Dr. Fitzer changed my life for the better. I finally feel like \u201Cmyself\u201D again — more confident, more energetic, and grateful every day for the care I received.",
    before: s1b,
    after: s1a,
  },
  {
    name: "Tawana B.",
    label: "Tawana B.",
    caption: "Tawana B.'s before-and-after weight-loss comparison following bariatric surgery.",
    before: s6b,
    after: s6a,
    afterPosition: "center 18%",
  },
  {
    name: "Tiffany W.",
    label: "Tiffany W.",
    caption: "Tiffany W. before and after her weight-loss surgery at Virginia Bariatric Surgery.",
    before: s20b,
    after: s20a,
    aspectClass: "aspect-[4/5]",
  },
  {
    name: "K. Campos",
    label: "K. Campos",
    caption: "K. Campos before and after gastric sleeve surgery with Dr. Matthew Fitzer in Northern Virginia.",
    quote:
      "It changed my life! They have a wonderful team. I was worried I\u2019d regret it, but I am very happy I did it. I feel so much better in every way. I didn\u2019t realize how many of my health issues were weight-related because I had been bigger my entire life. I am now able to do so many things that I\u2019ve never been able to. Thank you, Dr. Fitzer!",
    before: kcamposBeforeImg,
    after: kcamposAfterImg,
    aspectClass: "aspect-[3/4]",
    beforePosition: "center 20%",
    afterPosition: "center 20%",
  },
  {
    name: "K. S.",
    label: "K. S.",
    caption: "K. S.'s full-length before-and-after weight-loss transformation at Virginia Bariatric Surgery.",
    before: newStoryBeforeImg,
    after: newStoryAfterImg,
    aspectClass: "aspect-[1/2]",
    beforePosition: "center 25%",
    afterPosition: "center 25%",
  },
  {
    name: "Anonymous",
    label: "An anonymous Virginia Bariatric weight-loss surgery patient",
    caption: "An anonymous patient's side-by-side before-and-after weight-loss result after bariatric surgery with Dr. Matthew Fitzer in Northern Virginia.",
    before: s31,
    after: s31,
    single: true,
    aspectClass: "aspect-square",
  },
  {
    name: "Anonymous",
    label: "An anonymous bariatric surgery patient’s side-by-side result",
    caption: "An anonymous patient's before-and-after weight-loss result after bariatric surgery with Dr. Matthew Fitzer at Virginia Bariatric Surgery in Northern Virginia.",
    before: s32,
    after: s32,
    single: true,
    aspectClass: "aspect-square",
  },
  {
    name: "Anonymous",
    label: "An anonymous transformation",
    caption: "An anonymous patient's before-and-after weight-loss transformation at Virginia Bariatric Surgery.",
    before: s33b,
    after: s33a,
    aspectClass: "aspect-[1/2]",
    beforePosition: "center 25%",
    afterPosition: "center 20%",
  },
];


/** URL-safe anchor id for a story, used for deep links like /results#paula-c. */
export function storySlug(story: Story, index: number): string {
  const base = story.label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 60);
  return `${base || "story"}-${index + 1}`;
}

/** Largest available URL for an image reference (used for sitemap entries). */
export function largestUrl(img: ImgRef): string {
  if (!img.srcSet) return img.url;
  const last = img.srcSet.split(",").pop();
  return last ? last.trim().split(" ")[0]! : img.url;
}

/** Flat list of every before-and-after photo with its caption, for the image sitemap. */
export function resultsSitemapImages(): { loc: string; caption: string; title: string }[] {
  const out: { loc: string; caption: string; title: string }[] = [];
  const seen = new Set<string>();
  stories.forEach((story, index) => {
    const anchor = storySlug(story, index);
    const refs = story.single
      ? [{ img: story.before, suffix: "before and after" }]
      : [
          { img: story.before, suffix: "before" },
          { img: story.after, suffix: "after" },
        ];
    for (const { img, suffix } of refs) {
      const loc = largestUrl(img);
      if (seen.has(loc)) continue;
      seen.add(loc);
      out.push({
        loc,
        caption: story.caption,
        title: `${story.label} — ${suffix} weight-loss surgery (#${anchor})`,
      });
    }
  });
  return out;
}

/** Every story paired with its stable slug, ordered as rendered on /results. */
export function storiesWithSlugs(): { story: Story; slug: string }[] {
  return stories.map((story, index) => ({ story, slug: storySlug(story, index) }));
}

/** Look up one story by its slug, for the dedicated share page. */
export function findStoryBySlug(slug: string): { story: Story; slug: string; index: number } | undefined {
  const index = stories.findIndex((story, i) => storySlug(story, i) === slug);
  if (index === -1) return undefined;
  return { story: stories[index]!, slug, index };
}

/**
 * Story slugs are derived from the patient label, so renaming a story (for
 * example when anonymous labels were standardised) changes its URL. Old URLs
 * were already shared and indexed, so they must 301 to the current one rather
 * than 404.
 *
 * Explicit aliases below come from labels this data set actually used before.
 */
const STORY_SLUG_ALIASES: Record<string, string> = {
  "an-anonymous-full-length-transformation-4": "an-anonymous-transformation-4",
  "an-anonymous-head-to-toe-transformation-5": "another-amazing-anonymous-transformation-5",
  "amanda-g-at-a-later-milestone-14": "amanda-g-another-view-14",
};

/**
 * Resolve an incoming slug to the slug in use today.
 *
 * Returns `undefined` when the slug is already current or unknown (a genuine
 * 404 — never redirect an unknown URL to an unrelated story).
 */
export function resolveLegacyStorySlug(slug: string): string | undefined {
  const normalized = slug.trim().toLowerCase().replace(/^\/+|\/+$/g, "");
  if (!normalized || findStoryBySlug(normalized)) return undefined;

  const alias = STORY_SLUG_ALIASES[normalized];
  if (alias && findStoryBySlug(alias)) return alias;

  // Every slug ends in its 1-based position, which is stable per story: a
  // renamed label keeps the same trailing number, so the position identifies
  // the story even when the name part drifted.
  const match = normalized.match(/^(.*)-(\d+)$/);
  if (match) {
    const index = Number(match[2]) - 1;
    const story = stories[index];
    if (story) {
      const current = storySlug(story, index);
      if (current !== normalized) return current;
    }
  }

  // Slug with no trailing number ("paula-c"): match on the name part alone,
  // but only when exactly one story matches.
  const base = normalized.replace(/-\d+$/, "");
  const candidates = stories
    .map((story, index) => ({ slug: storySlug(story, index), base: storySlug(story, index).replace(/-\d+$/, "") }))
    .filter((c) => c.base === base);
  if (candidates.length === 1) return candidates[0]!.slug;

  return undefined;
}

export const DEFAULT_PHOTO_CREDIT = "Virginia Bariatric Surgery";
export const DEFAULT_PHOTO_PROVENANCE =
  "Patient photo shared with permission; unretouched.";
export const PHOTO_USAGE_INFO = "https://virginiabariatric.com/results";

/** Visible + structured credit and provenance for one story's photos. */
export function storyCredit(story: Story): {
  credit: string;
  provenance: string;
  copyrightNotice: string;
  creditLine: string;
} {
  const credit = story.credit ?? DEFAULT_PHOTO_CREDIT;
  const provenance = story.provenance ?? DEFAULT_PHOTO_PROVENANCE;
  return {
    credit,
    provenance,
    copyrightNotice: `\u00a9 ${credit}`,
    creditLine: `Photo credit: ${credit}. ${provenance}`,
  };
}

/** ImageObject rights fields matching the visible credit line. */
export function storyCreditSchema(story: Story) {
  const { credit, provenance, copyrightNotice } = storyCredit(story);
  // Kept deliberately lean: `license` + `acquireLicensePage` are what Google
  // Images reads, `creditText`/`creator`/`copyrightNotice` are the recommended
  // companions. Duplicate properties (copyrightHolder, usageInfo) were dropped
  // because they repeat on every photo and only inflate the inline payload.
  return {
    creditText: credit,
    copyrightNotice,
    // Linked to the sitewide organization node by @id so Google Images reads
    // a complete creator and audit tools do not see a bare name-only node.
    creator: {
      "@type": "Organization",
      "@id": "https://virginiabariatric.com/#organization",
      name: credit,
      url: "https://virginiabariatric.com",
    },
    license: PHOTO_USAGE_INFO,
    acquireLicensePage: PHOTO_USAGE_INFO,
    disambiguatingDescription: provenance,
  };
}

const SITE_ORIGIN = "https://virginiabariatric.com";

function absoluteUrl(url: string): string {
  return url.startsWith("http") ? url : `${SITE_ORIGIN}${url}`;
}

function encodingFormatFor(url: string): string | undefined {
  const ext = url.split("?")[0]!.split(".").pop()?.toLowerCase();
  if (!ext) return undefined;
  if (ext === "jpg" || ext === "jpeg") return "image/jpeg";
  if (ext === "png") return "image/png";
  if (ext === "webp") return "image/webp";
  if (ext === "avif") return "image/avif";
  return undefined;
}

/**
 * Full ImageObject node for one gallery photo: absolute URLs, dimensions,
 * MIME type, caption/description and the shared rights fields.
 */
export function storyImageObject(options: {
  id: string;
  img: ImgRef;
  story: Story;
  name: string;
  caption: string;
  representativeOfPage?: boolean;
  isPartOf?: string;
}): Record<string, unknown> {
  const { id, img, story, name, caption, representativeOfPage, isPartOf } = options;
  const contentUrl = absoluteUrl(largestUrl(img));
  const encodingFormat = encodingFormatFor(contentUrl);
  return {
    "@type": "ImageObject",
    "@id": id,
    contentUrl,
    thumbnailUrl: absoluteUrl(img.url),
    name,
    caption,
    ...(story.caption === caption ? {} : { description: story.caption }),
    ...(img.width ? { width: img.width } : {}),
    ...(img.height ? { height: img.height } : {}),
    ...(encodingFormat ? { encodingFormat } : {}),
    ...(representativeOfPage ? { representativeOfPage: true } : {}),
    ...(isPartOf ? { isPartOf: { "@id": isPartOf } } : {}),
    ...storyCreditSchema(story),
  };
}
